export var ACTION;
(function (ACTION) {
    ACTION["CHANGE_INPUT"] = "CHANGE_INPUT";
    ACTION["TOGGLE_CTA"] = "TOGGLE_CTA";
    ACTION["CHECK_LIMIT"] = "CHECK_LIMIT";
    ACTION["ON_CHANGE_DIMENSION"] = "ON_CHANGE_DIMENSION";
    ACTION["T_AND_C_CHECk"] = "T_AND_C_CHECk";
    ACTION["PRIVACY"] = "PRIVACY";
    ACTION["PRIVACY_POLICY"] = "PRIVACY_POLICY";
    ACTION["T_AND_C"] = "T_AND_C";
    ACTION["MOBILE_NUMBER_PROCEED"] = "MOBILE_NUMBER_PROCEED";
})(ACTION || (ACTION = {}));
